import axios from 'axios';
import { API_BASE_URL } from '../../config/env';
import { getAuthHeaders } from '../../utils/auth';

function authHeaders() {
  return getAuthHeaders();
}

/** List admin panel users with optional search / filter / pagination. */
export function getAdminUsers({ search = '', role = '', status = '', page = 1, limit = 10 } = {}) {
  const params = new URLSearchParams();
  if (search) params.append('search', search);
  if (role) params.append('role', role);
  if (status) params.append('status', status);
  params.append('page', page);
  params.append('limit', limit);

  return axios.get(`${API_BASE_URL}api/v1/admin-panel-users?${params.toString()}`, {
    headers: authHeaders(),
  });
}

/** Get a single admin panel user by ID. */
export function getAdminUser(id) {
  return axios.get(`${API_BASE_URL}api/v1/admin-panel-users/${id}`, {
    headers: authHeaders(),
  });
}

/** Create a new admin panel user. */
export function createAdminUser(payload) {
  return axios.post(`${API_BASE_URL}api/v1/admin-panel-users`, payload, {
    headers: authHeaders(),
  });
}

/** Update an admin panel user. */
export function updateAdminUser(id, payload) {
  return axios.put(`${API_BASE_URL}api/v1/admin-panel-users/${id}`, payload, {
    headers: authHeaders(),
  });
}

/** Soft-delete an admin panel user. */
export function deleteAdminUser(id) {
  return axios.delete(`${API_BASE_URL}api/v1/admin-panel-users/${id}`, {
    headers: authHeaders(),
  });
}
